import { Carousel, Container } from "react-bootstrap";
import "./css/style.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useRef, useState } from "react";
const reviews = [
    {
        name: "Сергеева Анна Игоревна",
        review: "Мы заказывали экран для фасада здания торгового центра, и команда справилась с задачей на отлично. Установили все вовремя, профессионально и без лишних хлопот. Сотрудник компании все нам объяснили и подобрали размер, расширение экрана, которое нам было необходимо! Очень довольны и благодарны!",
    },
    {
        name: "Морозова Кристина",
        review: "Компания «Сим Экран» предоставила нам светодиодный экран в небольшой концертный зал, который полностью преобразил все наши мероприятия. Яркие цвета и четкость изображения поразили всех!",
    },
    {
        name: "Екатерина",
        review: "Ребята из Сим Экран работают просто на высоте. Светодиодный пилорс настолько идеально вписался в фае перед нашей косметологией, мы получили массу положительных отзывов и поток клиентов увеличился.",
    },
    {
        name: "Рита",
        review: "Брали экран в прокат на корпорат компании, небольшой, всего 5 лет. Но оформление с использованием светодиодного экрана придало нашему празднику особый шик. Гости были в восторге, использовали его как фотозону в перерывах, а во время самого мероприятия запускали на нем видеоролики о компании и сотрудниках. Все остались довольны.",
    },
    {
        name: "Василий Станиславович",
        review: "Спасибо за быстроту работы и высокое качество экрана. Сотрудничество было простым и комфортным.",
    },
    {
        name: "Свешникова Алена",
        review: "Выражаем благодарность за качественный сервис и прекрасный продукт. Светодиодный экран производит фурор в нашем ТЦ!",
    },
    {
        name: "Мария",
        review: "Компания 'Сим Экран' предоставляет высококачественные светодиодные экраны, которые не только привлекают внимание, но и прекрасно вписываются в архитектурное окружение. Рекомендуем!",
    },
    {
        name: "Никита",
        review: "Это была наша первая работа с вашей компанией, и мы остались очень довольны. Работать с вами — одно удовольствие! Руководство осталось довольно результатом, экран – прослужит еще долгие годы!",
    },
    {
        name: "Прыжина Ксения",
        review: "Установили экран от 'Сим Экран' на нашем здании, и результаты превзошли все ожидания. Яркость, четкость изображения и простота управления — все на высшем уровне!",
    },
    {
        name: "Антонина",
        review: "Отличный сервис и профессиональный подход! 'Сим Экран' сделали полный монтаж в кратчайшие сроки. Очень довольны результатом. Привлекаем новых клиентов благодаря яркой рекламе на фасаде.",
    },
    {
        name: "Светлана",
        review: "Качество работы 'Сим Экран' впечатляет. Экраны долговечные, а их управление интуитивно понятное. Будем заказывать ещё! Создали уникальную атмосферу вокруг нашего здания. Гости в восторге от ярких и красочных изображений!",
    },
    {
        name: "Алина",
        review: "В 'Сим Экран' понимают потребности клиентов и предлагают индивидуальные решения. Это действительно стоит своих денег!",
    },
    {
        name: "Марат",
        review: "Браво команде за отличный продукт и обслуживание!",
    },
];

export default function Reviews(params) {
    const [plit, setplit] = useState(false);
    const sliderRef = useRef(null);

    const [showBlock, setShowBlock] = useState(false);

    useEffect(() => {
        // Пример переключения состояния через 2 секунды
        const timer = setTimeout(() => {
            setShowBlock(true);
        }, 200);

        return () => clearTimeout(timer);
    }, [showBlock]);

    const settings = {
        // dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        draggable: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };
    return (
        <>
            <section id="reviews" className="reviews sect">
                <Container className="">
                    <div className="reviews_title_button">
                        <div className="reviews_title">
                            <h2 className="block_title">
                                отзывы наших <br /> клиентов
                            </h2>
                        </div>
                        <div className="reviews_menu flex">
                            {/* <button
                                onClick={() => {
                                    setplit(!plit);
                                    setShowBlock(!showBlock);
                                }}
                                className="button t16 flex comp_vers">
                                {plit ? "свернуть" : "все отзывы"}
                            </button> */}
                            <div className={`services_arrows ${plit ? "hidden" : ""}`}>
                                <img
                                    className="services_arrows_item services_arrows_left"
                                    alt="стрелка влево"
                                    src="/img/arrow.png"
                                    onClick={goToPrev}
                                />
                                <img
                                    className="services_arrows_item services_arrows_right"
                                    alt="стрелка вправо"
                                    src="/img/arrow.png"
                                    onClick={goToNext}
                                />
                            </div>
                        </div>
                    </div>
                    {plit ? (
                        <div className="reviews_cards_grid">
                            {reviews.map((e, i) => (
                                <ReviewsItem key={i} cl={showBlock ? "show" : ""} name={e.name} text={e.review} />
                            ))}
                        </div>
                    ) : (
                        <div className="reviews_cards">
                            <Slider ref={sliderRef} {...settings}>
                                {reviews.map((e, i) => (
                                    <ReviewsItem key={i} cl={showBlock ? "show" : ""} name={e.name} text={e.review} />
                                ))}
                            </Slider>
                        </div>
                    )}
                    <button
                        onClick={() => {
                            setplit(!plit);
                            setShowBlock(!showBlock);
                        }}
                        className="button t16 flex">
                        {plit ? "свернуть" : "все отзывы"}
                    </button>
                </Container>
            </section>
        </>
    );
}

function ReviewsItem({ data = "", name, text, cl }) {
    return (
        <div className={`reviews_cards_item bl ${cl}`}>
            <p className="reviews_cards_item_date">{data}</p>
            <Costrat name={name} />
            <p className="reviews_cards_item_text">{text}</p>
        </div>
    );
}
const Costrat = ({ name }) => {
    // Извлекаем первый символ из строки name
    const firstChar = name.charAt(0);

    return (
        <p className="reviews_cards_item_name t20">
            <span>{firstChar}</span>
            {name.slice(1)}
        </p>
    );
};
